<script setup lang="ts">
// "Everything on one page" chapter: one bento grid instead of five identical
// alternating sections. Each tile pairs a short title with a real-UI mock
// (the Showcase* components in bare mode). Copy lives in content/0.index.yml.
export interface BentoTile {
  id: 'integrations' | 'domain' | 'content' | 'community' | 'niche'
  title: string
  description: string
}

defineProps<{ tiles: BentoTile[] }>()

// lg: 6-column grid. Row 1: integrations (wide) + domain; row 2: three tiles.
// md: 2 columns with integrations spanning both.
const SPAN: Record<BentoTile['id'], string> = {
  integrations: 'md:col-span-2 lg:col-span-4',
  domain: 'lg:col-span-2',
  content: 'lg:col-span-2',
  community: 'lg:col-span-2',
  niche: 'lg:col-span-2'
}
</script>

<template>
  <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-6">
    <article
      v-for="tile in tiles"
      :key="tile.id"
      class="flex flex-col overflow-hidden rounded-2xl border border-default bg-elevated/40 shadow-(--surface-shadow)"
      :class="SPAN[tile.id]"
    >
      <div class="px-6 pt-6 pb-5">
        <h3 class="text-base font-semibold text-highlighted">
          {{ tile.title }}
        </h3>
        <p class="mt-1.5 max-w-md text-sm leading-relaxed text-muted">
          {{ tile.description }}
        </p>
      </div>
      <div class="flex flex-1 flex-col px-4 pb-4 sm:px-5 sm:pb-5">
        <ShowcaseIntegrations
          v-if="tile.id === 'integrations'"
          class="flex-1"
          bare
        />
        <ShowcaseDomain
          v-else-if="tile.id === 'domain'"
          class="flex-1"
          bare
        />
        <ShowcaseContent
          v-else-if="tile.id === 'content'"
          class="flex-1"
          bare
        />
        <ShowcaseCommunity
          v-else-if="tile.id === 'community'"
          class="flex-1"
          bare
        />
        <ShowcaseNiche
          v-else-if="tile.id === 'niche'"
          class="flex-1"
          bare
        />
      </div>
    </article>
  </div>
</template>
